import 'babel-polyfill';
import r from 'render-dom';
import ReactDOM from 'react-dom';

import PromoteApp from './router';
import './css/icons.css';
import './css/index.css';

ReactDOM.render(
    r(PromoteApp),
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js